import React, { memo } from "react";
import { DeliveryTagInfoUIData } from "@super-ui/interfaces/SwiggyOne";
import { getScreenReaderTextForDeliveryInfo } from "@super-ui/helpers/OneWidget";
import { Container, PillContainer, DeliveryCount, DeliveryCountText, SubText } from "../styles/DeliveryTagInfo.styles";
import { AriaHidden, ScreenReaderOnly } from "@swiggy-private/core-ui";
import { ONE_WIDGET_TEST_IDS } from "@swiggy-private/cart-test-ids";

interface DeliveryTagInfoProps {
    data: DeliveryTagInfoUIData;
}

const DeliveryTagInfo = ({ data: { count, colorType, countSubText, countText } }: DeliveryTagInfoProps) => {
    const screenReaderText = getScreenReaderTextForDeliveryInfo(count, countSubText, countText);

    return (
        <>
            <ScreenReaderOnly text={screenReaderText} />
            <AriaHidden as="div">
                <Container data-testid={ONE_WIDGET_TEST_IDS.DELIVERY_TAG_INFO}>
                    <PillContainer colorType={colorType} data-testid={ONE_WIDGET_TEST_IDS.DELIVERY_TAG_COUNT}>
                        <DeliveryCount colorType={colorType} variant="V2.body2.neutral.bold">
                            {count}
                        </DeliveryCount>
                        <DeliveryCountText colorType={colorType} variant="V2.body3.neutral.medium">
                            {countText}
                        </DeliveryCountText>
                    </PillContainer>
                    <SubText
                        colorType={colorType}
                        variant="V2.overline.neutral.bold"
                        data-testid={ONE_WIDGET_TEST_IDS.DELIVERY_TAG_COUNT_TEXT}
                    >
                        {countSubText}
                    </SubText>
                </Container>
            </AriaHidden>
        </>
    );
};

export default memo(DeliveryTagInfo);
